module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hotel-card",
    on: {
      "click": function($event) {
        _vm.view(_vm.hData)
      }
    }
  }, [_c('div', {
    staticClass: "card-image-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.hData.HotelPicture
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-image-overlay"
  }), _vm._v(" "), (_vm.hData.free_cancellation) ? _c('div', {
    staticClass: "card-cancellation"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v("\n      Free Cancel\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.hData.HotelName))]), _vm._v(" "), _c('p', {
    staticClass: "card-desc"
  }, [_vm._v(_vm._s(_vm.cleanTags(_vm.hData.HotelAddress)))]), _vm._v(" "), (_vm.hData.StarRating) ? _c('div', {
    staticClass: "card-rating"
  }, [_c('i', {
    staticClass: "fas fa-star fa-fw"
  }), _vm._v("\n      " + _vm._s(_vm.hData.StarRating) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "card-price"
  }, [_c('span', {
    staticClass: "currency"
  }, [_vm._v(_vm._s(_vm.currencySymbol[_vm.currency.code]))]), _vm._v(" "), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.applyCurrency(_vm.hData.Price, false)))]), _vm._v(" "), _c('span', {
    staticClass: "per"
  }, [_vm._v("/night")])]), _vm._v(" "), _c('button', {
    staticClass: "card-btn"
  }, [_vm._v("View Details")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-43343fce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43343fce","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/D2DHotel/hotel-card.vue
// module id = 2078
// module chunks = 0